// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"7f62185e","771":"8ca48104","819":"8b1126fb"}[chunkId] + ".chunk.js";
};